import type { OrderDetailResponseDto } from "Infrastructure/Api/Api";
import { Resources } from "Infrastructure/Translation/Resources";
import { ChargeFormTab } from "Order/Modules/Payment/Components/Tabs/ChargeFormTab";
import { PaymentFormTab } from "Order/Modules/Payment/Components/Tabs/PaymentFormTab";
import type { TabType } from "Shared/Components/Tabs/Types/TabType";
import { Typography } from "@mui/material";
import type { TOptions } from "i18next";
import type { ObjPathProxy } from "ts-object-path";

export enum PaymentTabs {
	payments = "payments",
	charge = "charge",
}

const paymentResource = Resources.base.payment.shared;

export const getOrderPaymentTabs = (
	order: OrderDetailResponseDto,
	t: (
		resourcePath: ObjPathProxy<unknown, string>,
		options?: TOptions,
	) => string,
): TabType[] => {
	const tabs: TabType[] = [
		{
			index: PaymentTabs.payments,
			label: <Typography>{t(paymentResource.paymentDetails)}</Typography>,
			tab: <PaymentFormTab orderId={order.id} />,
		},
		{
			index: PaymentTabs.charge,
			label: <Typography>{t(paymentResource.chargeDetails)}</Typography>,
			tab: <ChargeFormTab order={order} />,
		},
	];

	return tabs;
};
